<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">Readers love</span> <span class="t2">Shadows in the Night</span></p>
<p class="p0"><span class="t1">by</span> <span class="t3">M.A. C</span><span class="t4">HURCH</span></p>
<p class="p2"><img alt="img1.jpg" height="300" src="Images/img1.jpg" width="200"/></p>
<p class="p3"><span class="t6">“The author’s writing style is a little quirky, but solid, clean, and straightforward, with a unique and original twist on the usual shifter tale. I enjoyed reading the book…”</span></p>
<p class="p4"><span class="t7">—Mrs. Condit &amp; Friends Read Books</span></p>
<p class="p3"><span class="t7">“Ms. Church… is able to give the readers a refreshing look at this genre with her story,</span> <span class="t8">Shadows in the Night</span><span class="t7">.”</span></p>
<p class="p4"><span class="t7">—Top 2 Bottom Reviews</span></p>
<p class="p3"><span class="t7">“M.A. Church brings some refreshing ideas into shifter lore with</span> <span class="t8">Shadows in the Night</span><span class="t7">. It made for some intriguing reading and great food for thought.”</span></p>
<p class="p5"><span class="t7">—Sensual Reads</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?5a81e1ee